import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Loader from "components/Loader";
//import HomeFilters from "pages/Home/filters";

// const YearMonthFilters = lazy(() =>
//   import("pages/FiltersSidebar/YearMonthFilters")
// );

const HomeFilters = lazy(() => import("pages/Home/filters"));
const DestinationsFilters = lazy(() => import("pages/Destinations/filters"));
const DetailsFilters = lazy(() => import("pages/Details/filters"));
const CompletedRoutesFilters = lazy(() => import("pages/CompletedRoutes/filters"));
const LicensingFilters = lazy(() => import("pages/Licensing/filters"));

const HomeFiltersPopups = lazy(() => import("pages/Home/filterspopups"));
const DestinationsFiltersPopups = lazy(() => import("pages/Destinations/filterspopups"));
const DetailsFiltersPopups = lazy(() => import("pages/Details/filterspopups"));
const CompletedRoutesPopups = lazy(() => import("pages/CompletedRoutes/filterspopups"));
const LicensingFiltersPopups = lazy(() => import("pages/Licensing/filterspopups"));


export default function SideBar() {
  return (
    <Suspense fallback={<Loader />}>
      <div className="p-2">

      <Switch>
          <Route exact path="/">
            <HomeFiltersPopups />
          </Route>
          <Route path="/destinations">
            <HomeFiltersPopups /> {/* DestinationsFiltersPopups */}
          </Route>
          <Route path="/details">
            <HomeFiltersPopups /> {/* DetailsFiltersPopups */}
          </Route>
          <Route path="/completedRoutes">
            <HomeFiltersPopups /> {/* CompletedRoutesPopups */}
          </Route>
          <Route path="/licensing">
            <HomeFiltersPopups /> {/* LicensingFiltersPopups */}
          </Route>
        </Switch>    

        {/* <YearMonthFilters /> */}
        
        <Switch>
          <Route exact path="/">
            <HomeFilters />
          </Route>
          <Route path="/destinations">
            <DestinationsFilters /> {/* DestinationsFilters */}
          </Route>
          <Route path="/details">
            <DetailsFilters /> {/* DetailsFilters */}
          </Route>
          <Route path="/completedRoutes">
            <CompletedRoutesFilters /> {/* CompletedRoutesFilters */}
          </Route>
          <Route path="/licensing">
            <LicensingFilters /> {/* LicensingFilters */}
          </Route>
        </Switch>
      </div>
    </Suspense>
  );
}
